// src/pages/MobileLogin.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import {
  logout as clearAuth,
  getAccessToken,
  getRefreshToken,
  refreshAccessToken,
} from "../services/authService";

// 管理者チェック: admin_me は非管理者で 403 となりコンソールが汚れるため auth/me を使う
async function fetchMe(token) {
  const res = await fetch("/api/auth/me/?_=" + Date.now(), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.ok ? await res.json() : null;
}

export default function MobileLogin() {
  const nav = useNavigate();
  // 判定が終わるまでフォームを出さない（一瞬ログイン画面が見えるのを防ぐ）
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // 社員として有効なトークンが残っていれば、ログイン画面を出さずに社員トップへ。
        // 無効なトークンや管理者トークンが残っている場合のみ従来どおり破棄する
        // （管理者トークンのままだと社員ログイン扱いで入れてしまうため）。
        let token = getAccessToken();
        if (!token && getRefreshToken()) token = await refreshAccessToken();
        if (!token) throw new Error("NO_TOKEN");

        let me = await fetchMe(token);
        if (!me && getRefreshToken()) {
          // アクセストークンの期限切れ（30分）だけならリフレッシュして継続
          token = await refreshAccessToken();
          me = await fetchMe(token);
        }
        if (!me) throw new Error("INVALID_SESSION");
        if (me.is_staff || me.is_superuser) throw new Error("ADMIN_TOKEN");

        if (alive) nav("/card_front", { replace: true });
      } catch (_) {
        clearAuth();
        if (alive) setChecking(false);
      }
    })();
    return () => { alive = false; };
  }, [nav]);

  if (checking) return null;

  return (
    <LoginForm
      title="社員ログイン"
      accent="#22c55e"
      mode="employee"
      onSuccess={(user) => {
        // 管理者が誤って社員ログインを使ったらブロック（トークンから判定）
        (async () => {
          try {
            const me = await fetchMe(getAccessToken());
            if (me && (me.is_staff || me.is_superuser)) {
              alert("管理者は管理者用ログインをご使用ください。");
              clearAuth();
              return;
            }
          } catch (_) {
            // ignore（社員ログインの通常経路）
          }
          localStorage.setItem("employeeId", user?.id ?? "");
          nav("/card_front", { replace: true }); // 社員のトップへ
        })();
      }}
    />
  );
}
